export default __webpack_public_path__ + "1545778fbb17bef9e441e1ea77fc5879.png";